import DOMPurify from "dompurify";

export const FORM_LABEL_HTML_SANITIZE = {
    ALLOWED_TAGS: ["a", "p", "br", "strong", "em", "b", "i", "u", "span"],
    ALLOWED_ATTR: ["href", "target", "rel"],
    ALLOW_DATA_ATTR: false,
};

/** Sanitize admin Consent / rich label HTML before rendering. */
export function sanitizeFormLabelHtml(html: string): string {
    return DOMPurify.sanitize(html, FORM_LABEL_HTML_SANITIZE);
}
